const titles: Record<string, string> = {
  '/': 'Overview',
  '/login': 'Login'
};

const handler = {
  get: function (target: typeof titles, name: string) {
    return Object.prototype.hasOwnProperty.call(target, name) ? target[name] + ' - tryinvoice.com' : 'tryinvoice.com';
  }
};

const MetaTitles = new Proxy(titles, handler);

export default MetaTitles;
